import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function ShopifyDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Shopify <br />Web Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>Managing your Shopify website on the go is easy and convenient using Shopify mobile features. Customized mobile features let you capture payments, complete orders, issue shipping notifications, access your dashboard, and update inventory using your mobile device.</p>
            <h3>Shopify Websites for Smart Sales & Easy Online Store Management</h3>
            <h4>Shopify E-commerce Features</h4>
            <p style={{ marginBottom: '3.5rem' }}>The platform offers varied plans with essential features included, as well as many additional options to extend the functionality for specialized requirements and offers;</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Custom design with our Shopify designers and developers</li>
              <li>100+ professional themes from leading web designers</li>
              <li>Affordable cost for startups and established businesses</li>
              <li>Mobile commerce ready store including a built-in mobile commerce shopping cart</li>
              <li>Managed Shopify technology and hosting allows you to focus on your business while Shopify takes care of maintenance and updates</li>
              <li>Full blogging functionality with user comments and discussions</li>
              <li>Full access to edit HTML and CSS of your store</li>
              <li>Fully-featured store CMS</li>
              <li>Free SSL certificate and site security</li>
              <li>Accept credit cards with Shopify payments</li>
              <li>Multiple (70) payment gateways from around the world</li>
              <li>Supports multiple languages (50+)</li>
              <li>Excellent Shopify customer support that is available 2</li>
            </ul>
            <h3>Analytics</h3>
            <p style={{ marginBottom: '3.5rem' }}>We integrate Google Analytics with your Shopify e-commerce website so you can track the performance of your store in terms of usage and traffic statistics.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/93b436bf0e70e2f8e7c4404f5e85266c3e184f18-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default ShopifyDevelopment